export default __webpack_public_path__ + "static/media/ic_search.4b02ac52.svg";